import axios from 'axios';
import { API_URL, MEDIA_TYPE_V2 } from '../config/constants';
import { ConversationHistory } from '../@types/llm-conversation';

class LlmService {
    getLlmModels(): Promise<any> {
        return axios.get(`${API_URL}api/v2/llm/models`, {headers: {'Content-Type': MEDIA_TYPE_V2}});
    }

    postLlmConversation(conversation: ConversationHistory): Promise<any> {
        return axios.post(`${API_URL}api/v2/llm/question`, conversation, {headers: {'Content-Type': MEDIA_TYPE_V2}});
    }
}

export default new LlmService();